export const REQUIRED_DISPUTE_SCOPES = [
  "write_shopify_payments_dispute_evidences",
  "write_shopify_payments_dispute_file_uploads",
] as const;

export function hasDisputeScopes(scopes: string[]): boolean {
  return REQUIRED_DISPUTE_SCOPES.every((scope) => scopes.includes(scope));
}
